module.exports = __webpack_public_path__ + "static/img/img_24.b1b9be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/images/img_24.png
// module id = OKB9
// module chunks = 18